import PropTypes from 'prop-types';
import React from 'react';
import LearningCenterPage from "../../components/Pages/LearningCenterPage";
import Layout from '../../components/Templates/Layout';

const SharedContainer = ({ layoutProps, pageProps }) =>
{
    const { headerProps, footerProps, breadcrumbProps } = layoutProps;
    const { headlineProps, gridContainerComp } = pageProps;

    return (
        <Layout
            headerProps={headerProps}
            footerProps={footerProps}
            breadcrumbProps={breadcrumbProps}
            hasHero
        >
            <LearningCenterPage
                title={headlineProps.title}
                description={headlineProps.description}
                postsGrid={gridContainerComp}
                categories={headerProps.categories}
            />
        </Layout>
    );
}

SharedContainer.propTypes = {
    layoutProps: PropTypes.object.isRequired, 
    pageProps: PropTypes.object.isRequired,
};

export default SharedContainer;
